var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOxzoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.61,
    height: 40.867,
    viewBox: "0 0 137.61 40.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    transform: "translate(-1935.887 -127.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1561",
    "data-name": "Trazado 1561",
    d: "M1961.116,152.659a20.846,20.846,0,0,0,.785-5.674c0-5.189-2.116-10.7-7.623-10.536-5.665,0-7.36,5.718-7.36,10.536a20.828,20.828,0,0,0,.193,2.89,33.928,33.928,0,0,0-6.167-1.187,21,21,0,0,0-5.007.117q-.049-.918-.05-1.878c0-11.878,6.946-19.62,18.72-19.62,13.509,0,18.577,9.885,18.577,19.872a27.272,27.272,0,0,1-.828,6.912,16.7,16.7,0,0,0-4.484-1.422A27.887,27.887,0,0,0,1961.116,152.659Z",
    fill: "#0061ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1562",
    "data-name": "Trazado 1562",
    d: "M1941.921,157.4c11.684-.908,15.049,3.854,20.8,6.272.089.037,2.9,1.1,3.169,1.226a19.385,19.385,0,0,1-11.44,3.278c-7.794-.019-14-3.483-16.75-10.155A21.427,21.427,0,0,1,1941.921,157.4Z",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1563",
    "data-name": "Trazado 1563",
    d: "M1936.46,153.45a19.749,19.749,0,0,1-.452-3.143s2.518-.75,8.4.386a24.743,24.743,0,0,1,14.927,9.282,30.232,30.232,0,0,0-8.611-3.763,36.439,36.439,0,0,0-13.524,0S1936.672,154.54,1936.46,153.45Z",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1564",
    "data-name": "Trazado 1564",
    d: "M1965.741,153.843a40.531,40.531,0,0,0-9.8.974,17.719,17.719,0,0,1,4.748,5.158c1.574,2.273,6.338,3.527,6.338,3.527a15.906,15.906,0,0,0,2.436-2.651,15.4,15.4,0,0,0,2.629-5.347A12.636,12.636,0,0,0,1965.741,153.843Z",
    fill: "#00a1ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1565",
    "data-name": "Trazado 1565",
    d: "M2002.4,127.537l-10.453,19.543,10.8,20.636H1990.18l-4.944-9.744-4.182,9.744h-12.359l11.035-20.309-10.449-19.87h12.454l4.68,9.124,3.765-9.124Z",
    fill: "#0061ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1566",
    "data-name": "Trazado 1566",
    d: "M2035.386,127.537l-12.479,28.64h12.331v11.539h-30.32l12.426-28.637h-13.13V127.537Z",
    fill: "#0061ad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1567",
    "data-name": "Trazado 1567",
    d: "M2073.5,147.688c0,13.211-7.567,20.486-19.05,20.486-12.187,0-19.2-7.529-19.2-20.744,0-12.183,7.123-20.123,19.2-20.123C2068.3,127.307,2073.5,137.445,2073.5,147.688Zm-26.939-.2c0,5,1.548,10.924,7.684,10.924,5.534,0,7.682-4.458,7.682-10.924,0-5.323-2.168-10.968-7.817-10.807C2048.295,136.684,2046.558,142.551,2046.558,147.491Z",
    fill: "#0061ad"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxzoLogo);
export default __webpack_public_path__ + "static/media/OXZO-logo.083b9e2fd3b948fd9a38b93543a692c4.svg";
export { ForwardRef as ReactComponent };